import { render, staticRenderFns } from "./HotelOfferQuote.vue?vue&type=template&id=03e024fc&"
import script from "./HotelOfferQuote.vue?vue&type=script&lang=js&"
export * from "./HotelOfferQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03e024fc')) {
      api.createRecord('03e024fc', component.options)
    } else {
      api.reload('03e024fc', component.options)
    }
    module.hot.accept("./HotelOfferQuote.vue?vue&type=template&id=03e024fc&", function () {
      api.rerender('03e024fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/HotelOfferQuote.vue"
export default component.exports